/**
 * Round floating points to two decimals.
 * @param {Number}
 * @return {Number}
 */
export function formatNumber(val) {
    if (typeof val !== 'number' || Number.isNaN(val)) {
        return '-';
    }

    return Number.isInteger(val) ? val : val.toFixed(2);
}

/**
 * Format production values
 * @param {Number} value
 * @return {String} formatted production value (locale formatted)
 */
export function formatProductionValue(value, locale = 'en-US', digits = 2) {
    if (Number.isInteger(value)) {
        return value.toLocaleString(locale);
    } else if (typeof value === 'number') {
        return value.toLocaleString(locale, {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits
        });
    }

    return null;
}

/**
 * Get percentage representation of floating point, rounded to two decimals.
 * @param {number} value
 * @return {String} percentage representation of floating point
 */
export function formatPercentage(value, locale = 'en-US') {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return '-';
    }
    const percentageValue = value * 100;
    return `${percentageValue.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}%`;
}

/**
 * Round a number to a specified number of decimal places. This is more accurate than toFixed due to improved rounding.
 * @param {Number} value
 * @param {Number} decimalPlaces
 * @return {Number} rounded number
 */
export function roundTo(value, decimalPlaces) {
    let factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
}
